<script setup>
  import { ref, computed, useTemplateRef, watchEffect } from 'vue';
  import { formatLocalized } from '@/composables/useDateHelper';
  
  const props = defineProps({
    unit: {
      type: String,
      required: true
    },
    positionX: {
      type: Number,
      required: true
    },
    lineColor: {
      type: String,
      required: true
    },
    displayValue: {
      type: String,
      required: true
    },
    point: {
      type: Object,
      required: true
    },
    graph: {
      type: [Object, null],
      required: true
    }
  });

  const toolTip = useTemplateRef('tooltip');

  const graph = ref(props.graph);
  const toolTipReady = ref(false);

  const value = computed(() => props.point ? props.point.y.toFixed(2) : null);
  const dateTime = computed(() => props.point ? formatLocalized(new Date(props.point.x), 'p') : null);
  const stemHeight = computed(() => props.graph ? props.graph.yAxis[0].height : null);
  const isInFuture = computed(() => props.point.x > Date.now());
  const tooltipXPosition = computed(() => {
    if (!toolTip.value) return props.positionX || 0;

    const offsetWidth = toolTip.value.offsetWidth / 2;
    const toolTipLeftEdge = props.positionX - offsetWidth;
    const toolTipRightEdge = props.positionX + offsetWidth;
    const edgePadding = 5;
    let clampedX = props.positionX;
    
    if (toolTipLeftEdge < props.graph.plotLeft) {
      clampedX = props.graph.plotLeft + offsetWidth + edgePadding;
    } else if (toolTipRightEdge > props.graph.plotLeft + props.graph.plotWidth) {
      clampedX = props.graph.plotLeft + props.graph.plotWidth - offsetWidth - edgePadding;
    }

    return clampedX;
  });

  const stemStyles = computed(() => ({
      '--jwx-tooltip-x': props.positionX + 'px',
      '--jwx-tooltip-stem-height': stemHeight.value + 'px',
      '--jwx-tooltip-stem-color': isInFuture.value ? props.lineColor : 'hsla(0, 0%, 61%, 1.0)',
    })
  );

  watchEffect(() => { if (toolTip.value) toolTipReady.value = true; });
</script>

<template>
  <Teleport :to="graph.container">
    <div 
      ref="tooltip"
      class="jwx-tide-graph__tooltip"
      :data-visible="true"
      :style="{ '--jwx-tooltip-x': tooltipXPosition + 'px' }"
    >
      <div class="jwx-tide-graph__tooltip-content">
        <div class="jwx-tide-graph__tooltip-value">{{ value }} {{  props.unit }}</div>
        <div class="jwx-tide-graph__tooltip-datetime">{{ props.displayValue }}</div>
      </div>
    </div>  
    <div 
      class="jwx-tide-graph__tooltip-stem"
      :data-visible="true"
      :style="stemStyles"
    ></div>     
  </Teleport>
</template>